<template>
  <div class="Catalog">
        <section v-for="(item, index) in catalogList" :key="index">
            <el-tooltip class="item" effect="light" :content="item.sectionname" placement="top-start">
                <p class="title"><span class="tag">{{item.sectionindexname}}</span><span class="name">{{item.sectionname}}</span></p>
            </el-tooltip>
            <ul>
                <el-tooltip v-for="(content, contentIndex) in item.taskinfolist" :key="contentIndex" class="item" effect="light" :content="content.taskname" placement="top-start">
                    <li @click="gotask(content.innerid, item.sectionindexname, content.taskindexname, content.isunlock, content.istry)" :class="{'active': taskid == content.innerid && taskid !== undefined}">
                        <span class="tag">{{content.taskindexname}}</span>
                        <span class="name">{{content.taskname}}</span>
                        <span class="time"><img src="../../../../common/images/catalog/icon-catalog-img.png" class="icon"  v-if="content.kmctype == '2'"/> 
                            <img src="../../../../common/images/catalog/icon-catalog-audio.png" class="icon"  v-else-if="content.kmctype == '6'"/> 
                            <img src="../../../../common/images/catalog/icon-catalog-video.png" class="icon"  v-else-if="content.kmctype == '4'"/>
                            
                            <template v-if="content.istry == 1"><p>试读</p></template>
                            <template v-else-if="content.isunlock == 0"><p>未解锁</p></template>
                            <template v-else>
                                <p v-if="content.kmctype != '2'">{{content.timelength | ChangeHourMinutestr}}</p>
                            </template>
                            
                        </span>
                    </li>
                </el-tooltip>
            </ul>
      </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getCourseTask} from 'api/course'
export default {
    name: 'Catalog',
    props: ['studyData'],
    data() {
        return {
            courseid: this.$route.query.courseid,
            taskid: this.$route.query.taskid,
            catalogList: [] // 章节列表
        }
    },
    mounted() {
        // 获取目录 单课程情况下不获取 系列课才获取
        if (this.studyData.coursetype == 2) {
            this.getCourseTaskList()
        }
    },
    methods: {
        gotask(taskid, sectionindexname, taskindexname) { // 课程id 章节 节  isunlock, istry 是否解锁 试读
            // 是否为试读情况
            // if (istry == 1) {
            //     this.$router.push({name: "Study", query: {courseid: this.courseid, taskid: taskid, sectionindexname: sectionindexname, taskindexname: taskindexname}})
            // } else if (isunlock == 1) {
            //     // 判断课程是否解锁 
                
            // } 
            this.$router.push({name: "Study", query: {courseid: this.courseid, taskid: taskid, sectionindexname: sectionindexname, taskindexname: taskindexname}})
        },
        getCourseTaskList() {
            // 获取目录
            this.setLoading(true)
            getCourseTask({
                data: {courseid: this.courseid},
                success: data => {
                    console.log('getCourseTask',data)
                    this.setLoading(false)
                    this.catalogList = data.data.content

                    this.updateRoute(this.catalogList)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        updateRoute(catalogList) {
            // 无任务id 情况下路由修改 默认取第一个章节
            if (!this.$route.query.taskid || this.$route.query.taskid == '') {
                let taskid = catalogList[0].taskinfolist[0].innerid,
                    sectionindexname = catalogList[0].taskinfolist[0].sectionindexname,
                    taskindexname = catalogList[0].taskinfolist[0].taskindexname

                    // 系列课情况下 任务详情里不带有章节名称 向上一层取得章节名称
                    if (sectionindexname == undefined) {
                        sectionindexname = catalogList[0].sectionindexname
                    }

                 this.$router.push({name: "Study", query: {courseid: this.courseid, taskid: taskid, sectionindexname: sectionindexname, taskindexname: taskindexname}})
            }
            //
        },
         ...mapActions([
            'setLoading'
        ]),
         ...mapGetters(['user']),
    },
    filters: {
        ChangeHourMinutestr(str) { // 转分钟
            if (str !== "0" && str !== "" && str !== null) {
                return ((Math.floor(str / 60)).toString().length < 2 ? "0" + (Math.floor(str / 60)).toString() : 
                    (Math.floor(str / 60)).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
            } else {
                return "";
            }
        }
    },
    watch: {
        $route() {
            this.taskid = this.$route.query.taskid
        }
    },
    computed: {},
    components: {}
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.Catalog {
    padding: 0 20px;
    padding-bottom: 100px;


    p.title {
        margin-top: 15px;
        span {
            color: #333;
            font-weight:500;
        }
    }
    ul {
        li {
            margin-top: 15px;
            overflow: hidden;
            cursor: pointer;

            span {
                float: left;
                font-size: 12px;
                color: #666;
                line-height: 14px;
            }

            &.active .tag,
            &.active .name,
            &:hover .tag,
            &:hover .name {
                color: #409EFF
            }
        }
    }
    .tag {
        display: inline-block;
        width: 60px;
    }
    .name {
        display: inline-block;
        margin-right: 7px;
        margin-left: 20px;
        width: 225px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .time {
        img {
            display: inline-block;
            margin-right: 2px;
            width: 14px;
            height: 14px;
            transform: translateY(0px);
            -webkit-transform: translateY(0px);
            -ms-transform: translateY(0px);
            -moz-transform: translateY(0px);
            -o-transform: translateY(0px);
        }
        p {
            float: right
        }
    }
}
.el-tooltip__popper {
    color: #666;
    font-size: 14px;
    border: none !important;
    width: 360px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);

   .popper__arrow {
        border-top-color:rgba(0,0,0,0.1) !important;
   } 
   .popper__arrow::after {
        border-width: 6px;
        // right: auto;
        // box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        // -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        // -ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        // -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        border-top-color: #fff !important;
    }
    .popper__arrow, .popper__arrow::after {
        margin-left: 5px;
        left: 0 !important;
   }
}

</style>